import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForRouteWiseCropDetails } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { LeafSupplierDetailsReportSchemaObject } from "../LeafSupplierDetailsReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import '../Pages/tableFooter.css';
import _ from 'lodash';

const screenCode = "LEAFSUPPLIERDETAILSREPORT";

export function LeafSupplierDetailsReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [footerData, setFooterData] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        qtyFrom: "",
        qtyTo: "",
        date: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        qtyFrom: "",
        qtyTo: "",
        date: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(LeafSupplierDetailsReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = [
        "registrationNumber", "nameToBePrinted", "netAmount"
    ];
    const csvHeaders = [
        { label: "Reg. Number", value: "registrationNumber" },
        { label: "Reg. Name", value: "nameToBePrinted" },
        { label: "Qty", value: "netAmount" }
    ];

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"
        });
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0"
        });
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
    }

    function handleQtyFromChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            qtyFrom: target.value,
        });
    }

    function handleQtyToChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            qtyTo: target.value,
        });
    }

    function handleDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            date: target.value,
        });
    }


    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, LeafSupplierDetailsReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLEAFSUPPLIERDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getLeafSupplierDetailsReportData(leafCollectionDetails);
        var tableData = result

        var totRecord = {
            registrationNumber: "Total",
            nameToBePrinted: "",
            netAmount: 0
        };

        tableData.forEach(value => {
            for (const property in value) {
                if (property !== "registrationNumber" && property !== "nameToBePrinted") {
                    totRecord[property] = (totRecord[property] === undefined ? 0 : parseFloat(totRecord[property]))
                        + parseFloat(value[property]);
                }
            }
        });

        setFooterData(totRecord);

        if (result.length > 0) {
            destroyDataTable();
            setIsTableHide(false);
            setReportData(result);
            createDataTable();
        }
    }

    function createDataTable() {
        $("#leafSUpplierDetails").DataTable({
            "order": []
        });
    }

    function destroyDataTable() {
        $("#leafSUpplierDetails").DataTable().destroy();
    }

    function createFile() {
        var settings = {
            sheetName: 'Leaf Supplier Details',
            fileName: 'LeafSupplierDetailsReport',
            writeOptions: {}
        }

        var copyOfCSVData = _.cloneDeep(reportData)

        var newData = {
            registrationNumber: "Total",
            netAmount: footerData.netAmount.toFixed(2)
        }
        copyOfCSVData.push(newData)

        xlsx(csvHeaders, copyOfCSVData, settings, true);
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            collectionTypeID: "0",
            qtyFrom: "",
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            qtyFrom: searchForm.qtyFrom,
            qtyTo: searchForm.qtyTo,
            date: searchForm.date
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Leaf Supplier Details Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="qtyFrom">Qty From *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="qtyFrom"
                                            name="qtyFrom"
                                            type="number"
                                            onChange={(e) => handleQtyToChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["qtyFrom"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["qtyFrom"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="qtyTo">Qty To *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="qtyTo"
                                            name="qtyTo"
                                            type="number"
                                            onChange={(e) => handleQtyFromChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["qtyTo"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["qtyTo"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="date">Month *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="month"
                                            onChange={(e) => handleDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div className="pt-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="leafSUpplierDetails" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Reg. Number</th>
                                                            <th>Reg Name</th>
                                                            <th style={{ textAlign: "right" }}>Qty</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForRouteWiseCropDetails
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan={2}>Total</th>
                                                            <th style={{ textAlign: "right" }}>{footerData.netAmount.toFixed(2)}</th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-3">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Leaf Supplier Details Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} fData={footerData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
